export * from './queries.js';
export * from './kb.js';
export * from './team.js';
/** Lupe's `/web/chat` input caps; the OS app sizes its requests to fit them. */
export const CHAT_LIMITS = { message: 4000, historyItems: 20, historyText: 8000, bodyBytes: 65536 };
export * from './journal.js';
